import { HealthProfessionalService } from '@app/modules/health-professional/services/health-professional.service';
import { HealthProfessional } from '@app/shared/models';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-rqe-warning',
  templateUrl: './modal-rqe-warning.component.html',
  styleUrls: ['./modal-rqe-warning.component.scss']
})
export class ModalRqeWarningComponent {
  @Input() isVisible = false;
  @Input() healthProfessional: HealthProfessional;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Input() healthProfessionalChange = new EventEmitter<HealthProfessional>();

  refuseLoading = false;

  constructor(
    private router: Router,
    private healthProfessionalService: HealthProfessionalService,
    private notification: NzNotificationService
  ) {}

  submit(value: boolean) {
    if (!value) {
      this.refuseRqe();
    } else {
      this.router.navigate(['/profile'], { state: { showModalPersonalData: true } });
      this.close();
    }
  }

  private async refuseRqe() {
    try {
      this.refuseLoading = true;
      this.healthProfessional.specialties.forEach(s => {
        if (s.notExists === undefined) {
          s.notExists = true;
        }
      });

      const saved = await this.healthProfessionalService
        .update(this.healthProfessional.userId, this.healthProfessional)
        .toPromise();

      this.close();
      this.healthProfessionalChange.emit(saved);
      this.notification.success('Sucesso', 'Registro atualizado');
    } catch (error) {
      console.error(error);
    }
    this.refuseLoading = false;
  }

  private close() {
    this.isVisibleChange.emit(false);
  }
}
